import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrash,
  faEdit,
  faArrowUp,
  faArrowDown,
  faSync,
  faPlus,
  faExclamation,
} from "@fortawesome/free-solid-svg-icons";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../Usuarios/Usuarios.css";

import { getUsuarios, deleteUsuario, saveUsuario } from "../../../services/usuarioservice";
import { getRoles } from "../../../services/rolservice";

export default function Usuarios() {
  const [usuarios, setUsuarios] = useState([]);
  const [roles, setRoles] = useState([]);

  const [filtroIdUsuario, setFiltroIdUsuario] = useState("");
  const [filtroNombre, setFiltroNombre] = useState("");
  const [filtroRol, setFiltroRol] = useState("");
  const [filtroEmail, setFiltroEmail] = useState("");
  const [ordenInvertido, setOrdenInvertido] = useState(false);

  // Modal Editar
  const [modalOpen, setModalOpen] = useState(false);
  const [usuarioEdit, setUsuarioEdit] = useState(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  // Modal Nuevo
  const [modalNuevoOpen, setModalNuevoOpen] = useState(false);
  const [nuevoUsuario, setNuevoUsuario] = useState({
    nombres: "",
    apellidos: "",
    telefono: "",
    email: "",
    usuario: "",
    password: "",
    idrol: 2,
  });

  const [saving, setSaving] = useState(false);

  // =========================
  // CARGAR USUARIOS
  // =========================
  const cargarUsuarios = async () => {
    try {
      const data = await getUsuarios();
      if (!data) return toast.error("No se recibieron usuarios");

      const normalizados = data.map((u) => ({
        idUsuario: u.idusuario,
        nombres: u.nombre,
        apellidos: u.apellido ?? "",
        telefono: u.telefono ?? "",
        email: u.email,
        usuario: u.usuario,
        rolId: u.idrol,
        rol: u.rol ?? (u.idrol === 1 ? "admin" : "usuario"),
        createdAt: u.fecha_reg ?? "-",
      }));

      setUsuarios(normalizados);
    } catch (error) {
      toast.error("Error al cargar usuarios");
    }
  };

  // =========================
  // CARGAR ROLES
  // =========================
  const cargarRoles = async () => {
    const data = await getRoles();
    if (!data) return toast.error("No se pudieron cargar los roles");
    setRoles(data);
  };

  useEffect(() => {
    cargarUsuarios();
    cargarRoles();
  }, []);

  // =========================
  // FILTROS
  // =========================
  const usuariosFiltrados = usuarios.filter((usuario) => {
    const idMatch = usuario.idUsuario.toString().includes(filtroIdUsuario);
    const nombreMatch = usuario.nombres
      .toLowerCase()
      .includes(filtroNombre.toLowerCase());
    const rolMatch = !filtroRol || usuario.rol === filtroRol;
    const emailMatch = usuario.email
      .toLowerCase()
      .includes(filtroEmail.toLowerCase());

    return idMatch && nombreMatch && rolMatch && emailMatch;
  });

  // =========================
  // ACCIONES
  // =========================
  const eliminarUsuario = async (idUsuario) => {
    //if (!window.confirm("¿Eliminar usuario?")) return;

    const res = await deleteUsuario(idUsuario);

    if (res.res === 1) {
      toast.success(res.mensaje || "Usuario eliminado");
      cargarUsuarios();
      setDeleteModalOpen(false);
    } else {
      toast.error(res.mensaje || "No se pudo eliminar");
    }
  };

  const editarUsuario = (usuario) => {
    setUsuarioEdit(usuario);
    setModalOpen(true);
  };

  const cerrarModal = () => {
    setModalOpen(false);
    setUsuarioEdit(null);
  };

  // =========================
  // NUEVO USUARIO
  // =========================
  const abrirModalNuevo = () => setModalNuevoOpen(true);

  const cerrarModalNuevo = () => {
    setModalNuevoOpen(false);
    setNuevoUsuario({
      nombres: "",
      apellidos: "",
      telefono: "",
      email: "",
      usuario: "",
      password: "",
      idrol: 2,
    });
  };

  const guardarNuevoUsuario = async () => {
    if (saving) return;
    setSaving(true);

    if (
      !nuevoUsuario.nombres ||
      !nuevoUsuario.apellidos ||
      !nuevoUsuario.usuario ||
      !nuevoUsuario.password
    ) {
      setSaving(false);
      return toast.error("Completa los campos obligatorios");
    }

    const res = await saveUsuario(nuevoUsuario);

    if (res.res === 1) {
      toast.success(res.mensaje || "Usuario creado");
      cerrarModalNuevo();
      cargarUsuarios();
    } else {
      toast.error(res.mensaje || "No se pudo crear usuario");
    }

    setSaving(false);
  };

  // =========================
  // EDITAR USUARIO
  // =========================
  const guardarEdicion = async () => {
    if (saving) return;
    setSaving(true);

    if (
      !usuarioEdit.nombres ||
      !usuarioEdit.apellidos ||
      !usuarioEdit.email
    ) {
      setSaving(false);
      return toast.error("Completa los campos obligatorios");
    }

    const payload = {
      idusuario: usuarioEdit.idUsuario,
      nombres: usuarioEdit.nombres,
      apellidos: usuarioEdit.apellidos,
      telefono: usuarioEdit.telefono,
      email: usuarioEdit.email,
      idrol: usuarioEdit.rolId, // <-- SE ENVÍA EL ROL
    };

    const res = await saveUsuario(payload);

    if (res.res === 1) {
      toast.success(res.mensaje || "Usuario actualizado");
      cerrarModal();
      cargarUsuarios();
    } else {
      toast.error(res.mensaje || "No se pudo actualizar");
    }

    setSaving(false);
  };

  const recargarUsuarios = () => {
    cargarUsuarios();
    toast.success("Usuarios recargados");
  };

  const invertirOrden = () => {
    setUsuarios([...usuarios].reverse());
    setOrdenInvertido(!ordenInvertido);
  };

  return (
    <div>
      <ToastContainer />

      {/* HEADER */}
      <div className="deFlexContent">
        <div className="nuevo-container">
          <button 
            className='nuevo' 
            onClick={abrirModalNuevo}
          >
            <FontAwesomeIcon icon={faPlus} />
            <span> Nuevo</span>
          </button>
        </div>

        <div className="filtrosContain">
          <input
            type="number"
            placeholder="ID Usuario"
            value={filtroIdUsuario}
            onChange={(e) => setFiltroIdUsuario(e.target.value)}
            className="input-modal"
          />

          <input
            type="text"
            placeholder="Nombre"
            value={filtroNombre}
            onChange={(e) => setFiltroNombre(e.target.value)}
            className="input-modal"
          />

          <input
            type="text"
            placeholder="Email"
            value={filtroEmail}
            onChange={(e) => setFiltroEmail(e.target.value)}
            className="input-modal"
          />

          <select
            value={filtroRol}
            onChange={(e) => setFiltroRol(e.target.value)}
            className="input-modal"
          >
            <option value="">Todos</option>
            {roles.map((r) => (
              <option key={r.idrol} value={r.rol}>
                {r.rol}
              </option>
            ))}
          </select>

          <button className="reload" onClick={recargarUsuarios}>
            <FontAwesomeIcon icon={faSync} />
          </button>

          <button className="reverse" onClick={invertirOrden}>
            <FontAwesomeIcon
              icon={ordenInvertido ? faArrowUp : faArrowDown}
            />
          </button>
        </div>
      </div>

      {/* TABLA */}
      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Nombre</th>
              <th>Email</th>
              <th>Rol</th>
              <th>Acciones</th>
            </tr>
          </thead>

          <tbody>
            {usuariosFiltrados.map((usuario) => (
              <tr key={usuario.idUsuario}>
                <td>{usuario.idUsuario}</td>
                <td>{usuario.nombres} {usuario.apellidos}</td>
                <td>{usuario.email}</td>
                <td
                  className={usuario.rol === "admin" ? "rolAdmin" : "rolUser"}
                >
                  {usuario.rol}
                </td>
                <td>
                  <button
                    className="eliminar"
                    onClick={() => {
                      setDeleteModalOpen(true);
                      setUsuarioEdit(usuario);
                      //eliminarUsuario(usuario.idUsuario)
                    }}
                  >
                    <FontAwesomeIcon icon={faTrash} />
                  </button>

                  <button
                    className="editar"
                    onClick={() => editarUsuario(usuario)}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* MODAL EDITAR */}
      {modalOpen && (
        <div className="modalOverlay" onClick={cerrarModal}>
          <div className="modalWindow" onClick={(e) => e.stopPropagation()}>
            <div className="modalHeader">
              <h2>Editar Usuario</h2>
              <button onClick={cerrarModal} className="modalCloseX">×</button>
            </div>

            <div className="modalBody">
              <input
                placeholder="Nombres"
                value={usuarioEdit.nombres}
                onChange={(e) =>
                  setUsuarioEdit({ ...usuarioEdit, nombres: e.target.value })
                }
                className="input-modal"
              />
              <input
                placeholder="Apellidos"
                value={usuarioEdit.apellidos}
                onChange={(e) =>
                  setUsuarioEdit({ ...usuarioEdit, apellidos: e.target.value })
                }
                className="input-modal"
              />
              <input
                placeholder="Teléfono"
                value={usuarioEdit.telefono}
                onChange={(e) =>
                  setUsuarioEdit({ ...usuarioEdit, telefono: e.target.value })
                }
                className="input-modal"
              />
              <input
                placeholder="Email"
                value={usuarioEdit.email}
                onChange={(e) =>
                  setUsuarioEdit({ ...usuarioEdit, email: e.target.value })
                }
                className="input-modal"
              />
              <input
                placeholder="Usuario"
                value={usuarioEdit.usuario}
                disabled
                className="input-modal"
              />

              {/* ===== COMBO DE ROLES EN EDITAR ===== */}
              <select
                value={usuarioEdit.rolId}
                onChange={(e) =>
                  setUsuarioEdit({ ...usuarioEdit, rolId: Number(e.target.value) })
                }
                className="input-modal"
              >
                {roles.map((r) => (
                  <option key={r.idrol} value={r.idrol}>
                    {r.rol}
                  </option>
                ))}
              </select>
            </div>

            <div className="modalFooter">
              <button onClick={cerrarModal} className="modalBtn btnCancelar">Cancelar</button>
              <button onClick={guardarEdicion} className="modalBtn btnGuardar" disabled={saving}>
                {saving ? "Guardando..." : "Guardar"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL NUEVO */}
      {modalNuevoOpen && (
        <div className="modalOverlay" onClick={cerrarModalNuevo}>
          <div className="modalWindow" onClick={(e) => e.stopPropagation()}>
            <div className="modalHeader">
              <h2>Nuevo Usuario</h2>
              <button onClick={cerrarModalNuevo} className="modalCloseX">×</button>
            </div>

            <div className="modalBody">
              <input
                placeholder="Nombres"
                value={nuevoUsuario.nombres}
                onChange={(e) =>
                  setNuevoUsuario({ ...nuevoUsuario, nombres: e.target.value })
                }
                className="input-modal"
              />
              <input
                placeholder="Apellidos"
                value={nuevoUsuario.apellidos}
                onChange={(e) =>
                  setNuevoUsuario({ ...nuevoUsuario, apellidos: e.target.value })
                }
                className="input-modal"
              />
              <input
                placeholder="Teléfono"
                value={nuevoUsuario.telefono}
                onChange={(e) =>
                  setNuevoUsuario({ ...nuevoUsuario, telefono: e.target.value })
                }
                className="input-modal"
              />
              <input
                placeholder="Email"
                value={nuevoUsuario.email}
                onChange={(e) =>
                  setNuevoUsuario({ ...nuevoUsuario, email: e.target.value })
                }
                className="input-modal"
              />
              <input
                placeholder="Usuario"
                value={nuevoUsuario.usuario}
                onChange={(e) =>
                  setNuevoUsuario({ ...nuevoUsuario, usuario: e.target.value })
                }
                className="input-modal"
              />
              <input
                type="password"
                placeholder="Password"
                value={nuevoUsuario.password}
                onChange={(e) =>
                  setNuevoUsuario({ ...nuevoUsuario, password: e.target.value })
                }
                className="input-modal"
              />

              {/* COMBO DE ROLES */}
              <select
                value={nuevoUsuario.idrol}
                onChange={(e) =>
                  setNuevoUsuario({ ...nuevoUsuario, idrol: Number(e.target.value) })
                }
                className="input-modal"
              >
                {roles.map((r) => (
                  <option key={r.idrol} value={r.idrol}>
                    {r.rol}
                  </option>
                ))}
              </select>
            </div>

            <div className="modalFooter">
              <button onClick={cerrarModalNuevo} className="modalBtn btnCancelar">Cancelar</button>
              <button onClick={guardarNuevoUsuario} className="modalBtn btnGuardar" disabled={saving}>
                {saving ? "Guardando..." : "Guardar"}
              </button>
            </div>
          </div>
        </div>
      )}

      {deleteModalOpen && (
          <div className="modalOverlay" onClick={() => setDeleteModalOpen(false)}>
              <div className="modalWindow deleteStyle" onClick={(e) => e.stopPropagation()}>
                  <div className="deleteHeader">
                      <button onClick={() => setDeleteModalOpen(false)} className="deleteCloseX">×</button>
                  </div>
  
                  <div className="deleteIconContainer">
                      <div className="deleteIconCircle">
                          <FontAwesomeIcon icon={faExclamation} /> 
                      </div>
                  </div>
  
                  <div className="deleteBodyContent">
                      <h3 className="deleteTitle">¿Eliminar registro?</h3>
                      <p className="deleteText">
                          Estás a punto de eliminar este usuario de forma permanente.
                      </p>
  
                      <div className="deleteActions">
                          <button onClick={() => setDeleteModalOpen(false)} className="btnCancelGhost">
                              Cancelar
                          </button>
                          <button onClick={() => eliminarUsuario(usuarioEdit.idUsuario)} className="btnConfirmFilled">
                              Sí, confirmar
                          </button>
                      </div>
                  </div>
              </div>
          </div>
      )}
    </div>
  );
}
